import React, { useContext, useEffect, useState } from "react"
import { Row, Col } from 'antd'
import { EyeOutlined, HeartOutlined } from '@ant-design/icons'
import { BlankSpace, PageContainer } from "../../component/Xcomponent"

import { Link, useLocation } from "react-router-dom"
import moment from "moment"
import { connect } from "react-redux"

import { ArticleCard } from "../BookmarkedArticles/BookmarkedArticlesStyle"

/* actions */
import { getBookmarkArticles, getBookmarkArticlesReset } from "../../action/getBookmarkArticlesAction"

import { s3_cdn } from "../../utils"

// Icons
import { DotIcon } from '../../component/CustomIcons'
import HeaderContext from "../../context/HeaderContext"

const BookmarkedArticles = (props) => {

    /* variables */
    const {
        getBookmarkArticles, getBookmarkArticlesReset, getBookmarkArticlesState
    } = props
    const location = useLocation()
    const {setTitle} = useContext(HeaderContext);
    setTitle("Bookmarks");

    useEffect(() => {
        getBookmarkArticles()
        return (() => {
            getBookmarkArticlesReset()
        })
    }, [])

    return (
        <PageContainer>
            { getBookmarkArticlesState.list.length > 0 &&
                <>
                    <Row gutter={[20, 20]}>
                        {getBookmarkArticlesState.list.map(data => (
                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                {/* <Link to={`BookmarkArticles/${data.slug}`}> */}
                                <Link to={`article-detail/${data.slug}`}>
                                    <ArticleCard
                                        cover={<img alt="example" src={`${s3_cdn()}article/${data.image_path}`} />}
                                    >
                                        <div className="description">
                                            <p>
                                                {data.title}
                                            </p>
                                            <div className="views">
                                                <span>{moment(data.createdAt).format("Do MMM YYYY")}</span>
                                                <span style={{ margin: "0 2px" }}>
                                                    <DotIcon size="6" height="6" />
                                                </span>
                                                <EyeOutlined />
                                                <span>{data.views} views</span>
                                                <span style={{ margin: "0 2px" }}>
                                                    <DotIcon size="6" height="6" />
                                                </span>
                                                <HeartOutlined />
                                                <span>{data.likes} Likes</span>
                                            </div>
                                        </div>
                                    </ArticleCard>
                                </Link>
                            </Col>
                        ))}
                    </Row>
                    <BlankSpace />
                </>
            }
        </PageContainer>
    )
}

const mapStateToProps = (state) => ({
    getBookmarkArticlesState: state.getBookmarkArticles,
})

const mapDispatchToProps = (dispatch) => ({
    getBookmarkArticles: (params) => dispatch(getBookmarkArticles(params)),
    getBookmarkArticlesReset: () => dispatch(getBookmarkArticlesReset()),
})

export default connect(mapStateToProps, mapDispatchToProps)(BookmarkedArticles)
